export default {
    edit: "compliance:edit",
    create: "compliance:create",
    delete: "compliance:delete",
    view: "compliance:view",
};
